import FinancialResumeAllEstablishments from './FinancialResumeAllEstablishments';

export default FinancialResumeAllEstablishments;